/* tslint:disable:jsx-no-lambda */
import * as React from 'react';
import { default as LeftNavigationPaneAsync } from './leftNavigationPane/leftNavigationPaneAsync';
import { ResizeHandle } from 'owa-resize-handle';
import { leftPaneWidthUpdated, getAppState } from '../../../appstate';
import type { Store } from 'redux';
import { connect } from 'react-redux';
import { safeRender, ThunkDispatch } from '../../../shared';
import EditorsAsync from './editors/editorsAsync';
import { NotificationBarHost } from 'owa-notification-bar';
import { PeopleHubAsync } from '../../../hub/components/peopleHubAsync';

import styles from './content.scss';

const MIN_LEFT_NAV_WIDTH = 198;
const MAX_LEFT_NAV_WIDTH = 320;

export interface OwnProps {
    store: Store<{}>;
}

export interface DispatchProps {
    onLeftNavResize: (width: number) => void;
}

export interface DataProps {
    isLeftNavVisible: boolean;
    leftNavWidth: number;
}

function Content(props: OwnProps & DispatchProps & DataProps): JSX.Element {
    const resiteHandler = React.useCallback(
        (leftWidth: number) =>
            onResize(leftWidth, MIN_LEFT_NAV_WIDTH, MAX_LEFT_NAV_WIDTH, props.onLeftNavResize),
        [props.onLeftNavResize]
    );

    return (
        <div className={styles.contentContainer}>
            {props.isLeftNavVisible && <LeftNavigationPaneAsync />}
            {props.isLeftNavVisible && <ResizeHandle onResize={resiteHandler} />}
            <div className={styles.component}>
                <PeopleHubAsync store={props.store} />
            </div>
            <EditorsAsync store={props.store} />
            <NotificationBarHost hostId={'PeopleModuleNotificationBarHost'} />
        </div>
    );
}

function onResize(
    width: number,
    minWidth: number,
    maxWidth: number,
    onResizeAction: (newWidth: number) => void
): void {
    let newWidth = width;

    if (width < minWidth) {
        newWidth = minWidth;
    }

    if (width > maxWidth) {
        newWidth = maxWidth;
    }

    onResizeAction(newWidth);
}

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
    return {
        onLeftNavResize: (newWidth: number) => dispatch(leftPaneWidthUpdated)(newWidth),
    };
};

const mapStateToProps = (rootState: {}): DataProps => {
    const state = getAppState(rootState);

    return {
        isLeftNavVisible: state.view.layoutState.isLeftNavVisible,
        leftNavWidth: state.view.layoutState.leftPaneWidth,
    };
};

export default connect<DataProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(safeRender(Content, 'Content'));
